
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "width": "24px",
    "height": "24px",
    "viewBox": "0 0 24 24",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  },
  "children": [
    {
      "tag": "title",
      "children": [
        {
          "text": "icon-dashboard-white"
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "icon-dashboard-white",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "d": "M2.39004068,16.915057 C2.39004068,17.8840034 3.13984624,18.6703325 4.061527,18.6703325 L11.1664181,18.6703325 L11.1664181,20.0904513 L8.65704016,20.0904513 C8.19512556,20.0904513 7.821297,20.4814674 7.821297,20.9648664 C7.821297,21.4482654 8.19512556,21.8392815 8.65704016,21.8392815 L15.3429854,21.8392815 C15.8049,21.8392815 16.1787286,21.4482654 16.1787286,20.9648664 C16.1787286,20.4836158 15.8049,20.0904513 15.3429854,20.0904513 L12.835756,20.0904513 L12.835756,18.6703325 L19.940647,18.6703325 C20.8623278,18.6703325 21.6121334,17.8840034 21.6121334,16.915057 L21.6121334,16.2791188 L2.39004068,16.2791188 L2.39004068,16.915057 Z",
            "id": "路径",
            "fill": "#FFFFFF",
            "fill-rule": "nonzero"
          }
        },
        {
          "tag": "path",
          "attrsMap": {
            "d": "M19.940647,3.16289256 C20.8623278,3.16289256 21.6099849,3.95137004 21.6099849,4.91816804 L21.6099849,4.91816804 L21.6099849,15.2650551 L2.38789224,15.2650551 L2.38789224,4.91816804 C2.38789224,3.95137004 3.1376978,3.16289256 4.05937856,3.16289256 L4.05937856,3.16289256 Z M18.4818563,6.6884826 C18.1789262,6.60684188 17.8588087,6.69277948 17.6375194,6.9140688 L17.6375194,6.9140688 L14.4492344,10.1023538 L11.6584108,7.3115302 C11.3189573,6.96992824 10.7668082,6.96992824 10.4252063,7.30723332 L10.4252063,7.30723332 L6.14336536,11.5461054 C5.79961496,11.885559 5.79746652,12.437708 6.13692004,12.7814584 C6.30020148,12.9468883 6.5214908,13.0392712 6.75352232,13.0414197 C6.98555384,13.0414197 7.20684316,12.9511852 7.37227304,12.7879038 L7.37227304,12.7879038 L11.0375117,9.16133704 L13.8304837,11.954309 C13.9937651,12.1197389 14.2150544,12.2121218 14.447086,12.2121218 C14.6791175,12.2121218 14.9025552,12.1175905 15.0658367,11.954309 L15.0658367,11.954309 L18.8728724,8.1494218 C19.0941617,7.92813248 19.1800993,7.60586648 19.100607,7.30723332 C19.0189663,7.00430328 18.7826379,6.77012332 18.4818563,6.6884826 Z",
            "id": "形状结合",
            "fill": "#FFFFFF",
            "fill-rule": "nonzero"
          }
        }
      ]
    }
  ]
})
    }
  